import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { MoneySourceEditService } from '../../service/money-source-edit/money-source-edit.service';

@Component({
	selector: 'app-money-source-edit',
	templateUrl: './money-source-edit.component.html',
	providers: [
		MoneySourceEditService,
		HttpModule
	]
})
export class MoneySourceEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	moneySource: FormGroup;
	ID: string;
	Nome: string;
	Ativo: boolean;
	UsuarioIDCriacao: string;
	DataCriacao: any;

	constructor(fb: FormBuilder, private moneySourceEditService: MoneySourceEditService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.moneySource = fb.group({
			'ID': '',
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.moneySourceEditService.loadMoneySource(this.token, this.ID).subscribe(result => {
				var updateCompanyTtype = result.Result;
				this.moneySource.setValue({
					ID: updateCompanyTtype.ID,
					Nome: updateCompanyTtype.Nome,
					Ativo: updateCompanyTtype.Ativo
				});
			})
		}, error => {
			console.log(error);
		});
	}
	
	editMoneySource(value: any) {
		console.log(value);
		this.moneySourceEditService.editMoneySource(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/origem-recurso');

		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/origem-recurso');
	}

}



// WEBPACK FOOTER //
// ./src/app/money-source/component/money-source-edit/money-source-edit.component.ts